import React, { useEffect } from 'react'
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Signup from './pages/Auth/Signup';
import Login from './pages/Auth/Login';
import Profile from './pages/Profile/Profile';
import OrgProfile from './pages/Org/OrgProfile';
import RequestAccessForm from './pages/RequestAccessForm/RequestAccessForm';
import ApprovalPage from './pages/ApprovalPage';
import Menu from './pages/Menu/Menu';
import DocAccess from './pages/Accessibility/DocAccess';
import AVAccess from './pages/Accessibility/AVAccessibility';
import AVAccessNew from './pages/Accessibility/AVAccessibilityNew';
import ParsingForm from './pages/Opportunities/ParsingForm';
import Opportunity from './pages/Opportunities/Opportunity';
import InfoAccess from './pages/InfoAccess/InfoAccess';
import OpportunityBot from './pages/Opportunities/OpportunityBot';
import DashBoard from './pages/Home/DashBoard';
import AvUploadingPage from './pages/Accessibility/avUpload';
import DocUploadingPage from './pages/Accessibility/docUpload';
import BookShelf from './pages/BookShelf/BookShelf';
import Library from './pages/Library/Library';
import JobApplyPage from './pages/Opportunities/jobApply';
import ResumeForJobs from './pages/Opportunities/ResumeForJobs';
import ResumeUploadingPage from './pages/Opportunities/ResumeUpload';
import LinkPhone from './pages/Auth/LinkPhone';
import WhiteList from './pages/WhiteList/WhiteList';
import SocketHandler from './components/SocketHandler';
import AccessNews from './pages/News/InfoAccess';
import CategoryPage from './components/CategoryPage/CategoryPage';
import BookCategoryPage from './components/BookCategoryPage/BookCategoryPage';
import BookListPage from './components/BookListPage/BookListPage';
import BookDetailPage from './components/BookDetailPage/BookDetailPage';
import Editprofile from './pages/Profile/EditProfile';
import EditAccount from './pages/Profile/EditAccount';
import ResetPassword from './pages/Profile/PasswordReset';
import LinkEmail from './pages/Profile/LinkEmail';
import BrowserAgent from './pages/BrowserAgent/BrowserAgent.js';
import Fellowship from './pages/Fellowship/Fellowship';
import ITutor from './pages/ITutor/ITutor';
import ForgotPassword from './pages/Auth/ForgotPassword';
import ResetPasswordToken from './pages/Auth/ResetPasswordToken';
import AccessibilityRouteSupport from './components/AccessibilityRouteSupport';
import ITutorDemo from './pages/ITutorDemo/ITutorDemo';


function App() {

  return (
    <BrowserRouter>
      <AccessibilityRouteSupport />
      <SocketHandler/>
      <Routes>
        <Route path='/signup' Component={Signup} />
        <Route path='/login' Component={Login}/>
        <Route path='/forgot-password' Component={ForgotPassword}/>
        <Route path='/reset-password' Component={ResetPasswordToken}/>
        {/* <Route path='/link' Component={Link}/> */}
        <Route path='/link' Component={LinkPhone}/>
        <Route path='/Menu' Component={Menu}/>
        <Route path='/docaccess' Component={DocAccess}/>
        <Route path='/docaccess/new' Component={DocAccess}/>
        <Route path='/avaccess' Component={AVAccess}/>
        <Route path='/avaccess/new' Component={AVAccessNew}/>
        <Route path='/library' Component={Library}/>

        {/* nab lib routes */}
        {/* <Route path='/library' Component={CategoryPage} /> */}
        <Route path='/category/:language/books' Component={BookCategoryPage} />
        <Route path='/category/:language/:mainCategory/:category' Component={BookListPage} />
        <Route path='/play/:mainCategory/:category/:bookName' Component={BookDetailPage} />
        

        <Route path='/' Component={DashBoard}/>
        <Route path='/profile' Component={Profile}/>
        <Route path='/edit-profile' Component={Editprofile}/>
        <Route path='/edit-account' Component={EditAccount}/>
        <Route path='/profile/reset-password' Component={ResetPassword}/>
        <Route path='/link/:toLink' Component={LinkEmail}/>
        <Route path='/orgProfile' Component={OrgProfile}/>
        <Route path='/requestAccess' Component={RequestAccessForm}/>
        <Route path='/whitelist' Component={WhiteList}></Route>
        <Route path='/approval' Component={ApprovalPage}/>
        <Route path='/opportunity' Component={ParsingForm}/>
        <Route path='/opportunity/new' Component={ParsingForm}/>
        <Route path='/opportunity/chatbot' Component={OpportunityBot}/>
        <Route path='/jobs' Component={Opportunity}/>
        <Route path='/appliedjob' Component={JobApplyPage}></Route>
        <Route path='/chatbot' Component={InfoAccess}/>
        <Route path='/browser-agent' Component={BrowserAgent}/>
        <Route path='/fellowship' Component={Fellowship}/>
        <Route path='/itutor' Component={ITutor}/>
        <Route path='/itutor-dev' Component={ITutorDemo}/>
        <Route path='/news' Component={AccessNews}/>
        <Route path='/resumeforjobs' Component={ResumeForJobs}></Route>
        <Route path='/opportunity/uploadingResume/:purpose' Component={ResumeUploadingPage}></Route>
        <Route path='/avaccess/uploading' Component={AvUploadingPage}></Route>
        <Route path='/docaccess/uploading' Component={DocUploadingPage}></Route>
        <Route path='/bookshelf' Component={BookShelf}></Route>
      </Routes>
    </BrowserRouter>
  )
}

export default App
